import { Component, OnInit, Input, OnChanges, SimpleChanges, Injector } from '@angular/core';
import { TaskStatus } from './taskstatus';
import { TaskStatusService } from './taskstatus.services';
import { TBarParams } from 'src/app/cp-barschart/cp-bar';
import { TaskItem } from '../../taskcommon/taskcommon.class';
import { PageBase } from 'src/app/shared/library/page.base';

@Component({
    selector: 'cp-taskstatus',
    templateUrl: './taskstatus.component.html',
    styleUrls: ['./taskstatus.component.css'],
    standalone: false
})

export class TaskStatusComponent extends PageBase implements OnInit, OnChanges {

  @Input() taskitem: TaskItem;
  paramChart: TBarParams[] = [];
  taskstatus: TaskStatus = new TaskStatus();
  isHideLoading = true;

  constructor(private taskstatusservice: TaskStatusService,
              public ObjInjector: Injector)
  {
    super(ObjInjector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.taskstatus.id = this.taskstatus.percentageState = 0;
    this.taskstatus.listMonth = [];
    this.taskitem = new TaskItem();
  }

  getFormattedNumberPercentage(value: number): string{
    if (!value)
    {
      value = 0.0;
    }
    return value.toLocaleString(navigator.language, { minimumFractionDigits: 2, maximumFractionDigits: 6 } );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.taskitem) {
      this.isHideLoading = false;
      this.load();
    }
  }

  async load() {
    this.taskstatus = await this.taskstatusservice.GetInfoTask(this.taskitem);
    if (typeof (this.taskstatus.percentageState) !== 'undefined') {
      this.paramChart = [];
      this.taskstatus.listMonth = this.taskstatus.listMonth.slice(0, 4);
      this.taskstatus.listMonth.forEach(itm => {
        this.paramChart.push(this.createParams(itm.month, itm.percentageState));
      });
    }
    this.isHideLoading = true;
  }

  setParamChart() {
    this.paramChart.push(this.createParams('SET', 100));
    this.paramChart.push(this.createParams('OUT', 22));
    this.paramChart.push(this.createParams('NOV', 95));
    this.paramChart.push(this.createParams('DEZ', 54));
  }

  createParams(mes: string, perc: number) {
    const par = new TBarParams();
    par.text = mes;
    par.percent = perc;
    return par;
  }

  onReceiveLiterals() {}
}
